import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

export interface BsCustomDates {
  label: string;
  value: Date | Date[];
}


export class BsCustomDatesViewComponent {
   isCustomRangeShown: true;
   ranges: BsCustomDates[];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'bs-custom-date-view',
  template: `
    <div class="bs-datepicker-predefined-btns">
      <button *ngFor="let range of ranges">{{ range.label }}</button>
      <button *ngIf="isCustomRangeShown">Custom Range</button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isCustomRangeShown': [{ type: Input },],
'ranges': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../.tmp/datepicker/themes/bs/bs-custom-dates-view.component.ts